import {DomainObject} from 'shared/store';
import {computed, observable, makeObservable} from 'mobx';
import moment from 'moment';
import _ from 'lodash';
import {t} from 'shared/core';
import {rangeDate} from 'shared/tools/dates';

class ScheduleRule extends DomainObject {
  repeatDays = [];
  repeatEndsOn;

  _relations = {
    _dates: ['repeatEndsOn']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      repeatDays: observable,
      repeatEndsOn: observable,
      summary: computed
    });

    this.merge(other);
  }

  get summary() {
    return t('time_tracking.shifts.REPEAT_SUMMARY', {
      days: _.sortBy(this.repeatDays).map(day => moment.weekdaysShort()[day]).join(', '),
      date: rangeDate(this.repeatEndsOn)
    });
  }

  toJS() {
    return {
      repeatDays: _.sortBy(this.repeatDays),
      repeatEndsOn: this.repeatEndsOn && moment(this.repeatEndsOn).format('YYYY-MM-DD')
    };
  }
}

export default ScheduleRule;
